import { Const } from '@app/shared';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/finally';
import { ToastrService } from "ngx-toastr";

import { environment } from '../../environments/environment';
import { I18nService, Logger, AuthenticationService } from '../core';
import { Subject } from 'rxjs';

const log = new Logger('Login');

@Component({
  selector: 'iw-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  integrationCita = Const.INTEGRACION_CITA;
  version: string = environment.version;
  error: string = null;
  loginForm: FormGroup;
  isLoading = false;
  // Define se el usuario debe cambiar la contraseña
  changePassword: boolean = false;
  // formulario de cambio de contraseña
  changePasswordForm: FormGroup;
  // controla el cargando del cambio de contraseña
  changePasswordLoading: boolean = false;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  // Expresion regular para validar minuscula, mayuscula, numero
  pwdPattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$';
  // Mensajes segun tipo de validacion
  validation_messages = {
    'password': [
      { type: 'required', message: 'Debe ingresar la nueva contraseña' },
      { type: 'pattern', message: 'La contraseña nueva debe tener al menos una mayúscula, una minúscula y un número' }
    ],
    'confirm_password': [
      { type: 'required', message: 'Por favor confirma tu nueva contraseña' },
      { type: 'areEqual', message: 'Las constraseñas no coinciden' }
    ],
    }

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private i18nService: I18nService,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
  ) {
    this.createForm();
  }

  ngOnInit() {
    // Si existe una sesión redireccionar a la raíz
    if (this.authenticationService.isAuthenticated()) {
      this.router.navigate(['/'], { replaceUrl: true });
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Retorna las clases de los inputs.
   *
   * @param {string} control
   * @returns
   * @memberof LoginComponent
   */
  cssClassInput(control: string) {
    const _control = this.loginForm.get(control);
    const isInvalid = _control.invalid && (_control.dirty || _control.touched);
    const isValid = _control.valid && _control.dirty;
    return {
      'is-invalid': isInvalid,
      'is-valid': isValid
    };
  }

  /**
   * Utiliza el servicio de autentificación para realizar
   * el inicio de sesión del usuario.
   *
   * @memberof LoginComponent
   */
  login() {
    this.isLoading = true;
    this.authenticationService
      .login(this.loginForm.value)
      .finally(() => {
        this.loginForm.markAsPristine();
        this.isLoading = false;
      })
      .subscribe(
        user => {
          log.debug(`${user.user.username} successfully logged in.`);
          if(user.changePassword){
            this.changePassword = true;
            this.createChangePassword();
          }else{
            this.router.navigate(['/'], { replaceUrl: true });
          }
        },
        error => {
          log.debug(`Login error: ${error.message}`);
          this.error = error;
        }
      );
  }

  /**
   *Cambiar la contraseña del usuario
   *
   * @memberof LoginComponent
   */
  newPassword(){
    if (this.changePasswordForm.controls['oldPassword'].value != this.changePasswordForm.controls['newPassword'].value) {
      this.changePasswordLoading = true;
      this.authenticationService.changePassword(this.changePasswordForm.controls['oldPassword'].value, this.changePasswordForm.controls['newPassword'].value).subscribe(res=>{
        if(res){
          this.changePasswordLoading = false;
          this.router.navigate(['/'], { replaceUrl: true });
        }
      }, err=>{
        this.changePasswordLoading = false;
      })
    } else {
      this.toastr.warning('La contraseña nueva debe ser diferente a la contraseña actual, verifica e intentalo de nuevo')
    }

  }

  /**
   * Cambia el lenguaje de la app.
   *
   * @param {string} language
   * @memberof LoginComponent
   */
  setLanguage(language: string) {
    this.i18nService.language = language;
  }

  /**
   * Retorna el lenguaje actual.
   *
   * @readonly
   * @type {string}
   * @memberof LoginComponent
   */
  get currentLanguage(): string {
    return this.i18nService.language;
  }

  /**
   * Retorna una lista con los lenguajes disponibles.
   *
   * @readonly
   * @type {string[]}
   * @memberof LoginComponent
   */
  get languages(): string[] {
    return this.i18nService.supportedLanguages;
  }

  /**
   * Crea un formulario para el login.
   *
   * @private
   * @memberof LoginComponent
   */
  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true
    });
  }

  /**
   *Crea el formulario de cambio de contraseña
   *
   * @private
   * @memberof LoginComponent
   */
  private createChangePassword(){
    this.changePasswordForm = this.formBuilder.group({
      oldPassword: [
                    '',
                    Validators.required
                  ],
      newPassword: [
                    '',
                    Validators.compose([
                      Validators.required,
                      Validators.pattern(this.pwdPattern)
                    ])
                  ],
      confirmPassword: [
                        '',
                        Validators.compose([
                          Validators.required,
                        ])
                      ]
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts